import { Lock } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styes.module.css'

const messageText = 'Editing in progress'

export const LockMessage: React.FC = () => (
  <div className={css.lock_wrapper}>
    <div className={css.message}>
      <Lock className={css.icon} />
      <p className={css.label}>{messageText}</p>
    </div>
  </div>
)
